function scriptExists(url) {
  return document.querySelectorAll(`script[src="${url}"]`).length > 0;
}

//If Youtube API exists
if (typeof YT === 'undefined') {
  let tagScript = document.createElement('script');
  tagScript.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tagScript, firstScriptTag);
}

if (!customElements.get('video-banner')) {
  customElements.define('video-banner', class VideoBanner extends HTMLElement {
    constructor() {
      super();

      this.isHiddenClass = 'is-hidden';
      this.videoYoutube = this.querySelector('.js-video-youtube');
      this.videoWistia = this.querySelector('.js-video-wistia');
      this.videoCover = this.querySelector('.js-video-image-btn');
      this.videoContent = this.querySelector('.js-video-content');
      this.buttonPlay = this.querySelector('.js-video-play');
      this.players = []

      this.initVideoYoutube = this.initVideoYoutube.bind(this)
      this.initVideoWistia = this.initVideoWistia.bind(this)

      if (this.videoWistia !== null) {
        this.initVideoWistia();
      }
      if (this.videoYoutube !== null) {
        this.initVideoYoutube();
      }
    }

    initVideoYoutube() {
      const buttonPlay = this.querySelector('.js-video-play');
      const videoIndex = this.videoYoutube.getAttribute('data-index');
      const videoCover = this.videoCover;
      const videoContent = this.videoContent;
      const videoId = this.videoYoutube.getAttribute('data-video-id');
      const isHiddenClass = this.isHiddenClass;

      const options = {
        videoId: videoId,
        playerVars: {
          autoplay: 0, // Auto-play the video on load
          playsinline: 1,
          loop: 1, // Run the video in a loop
          controls: 1, // Show pause/play buttons in player
          showinfo: 0, // Hide the video title
          showsearch: 0,
          modestbranding: 1, // Hide the Youtube Logo
          rel: 0,
          disablekb: 1,
          fs: 0, // Hide the full screen button
          cc_load_policy: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 0, // Hide video controls when playing
        },
        events: {
          onStateChange: function (event) {
            if (event.data == 1) {
              // playing
              videoCover.classList.add(isHiddenClass);
              videoContent.classList.add(isHiddenClass);
            } else if (event.data == 2) {
              // paused
              videoCover.classList.remove(isHiddenClass);
              videoContent.classList.remove(isHiddenClass);
            }
          }
        }
      }

      // Init Video
      const player = new YT.Player(this.videoYoutube, options);

      // Add to players array
      const video = {
        index: +videoIndex,
        video: player,
        type: 'youtube'
      }
      this.players.push(video)

      // Toggle play button
      buttonPlay.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleVideoPlay(buttonPlay, player, 'youtube');
      });

      // Get the closest element of selector
      function getClosest(elem, selector) {
        let elemTemp = elem

        for (; elemTemp && elemTemp !== document; elemTemp = elemTemp.parentNode) {
          if (elemTemp.matches(selector)) {
            return elemTemp
          }
        }
        return null
      }
    }

    initVideoWistia() {
      const wistia_video_id = this.videoWistia.getAttribute('data-video-id');
      const videoCover = this.videoCover;
      const videoContent = this.videoContent;
      const buttonPlay = this.buttonPlay;
      const toggleVideoPlay = this.toggleVideoPlay;
      const isHiddenClass = this.isHiddenClass;
      const wistaScript = "//fast.wistia.com/assets/external/E-v1.js";

      //If Wista API exists
      if( wistia_video_id && !scriptExists(wistaScript)) {
        let tagWistaScript = document.createElement('script');
        tagWistaScript.src = wistaScript;
        let firstWistaScriptTag = document.getElementsByTagName('script')[0];
        firstWistaScriptTag.parentNode.insertBefore(tagWistaScript, firstWistaScriptTag);
      }

      window._wq = window._wq || [];
      _wq.push({
        id: wistia_video_id, onReady: function (video) {
          video.videoWidth(1000, { constrain: true });
          video.bind("end", function() {
            videoCover.classList.remove(isHiddenClass);
            videoContent.classList.remove(isHiddenClass);
          });
          video.bind("play", function() {
            // play
            videoCover.classList.add(isHiddenClass);
            videoContent.classList.add(isHiddenClass);
          });
          buttonPlay.addEventListener('click', (event) => {
            event.preventDefault();
            toggleVideoPlay(buttonPlay, video, 'wistia');
          });
        }
      });
    }

    toggleVideoPlay(button, videoPlayer, videoType) {
      if (videoType === 'youtube') videoPlayer.playVideo();
      if (videoType === 'wistia') videoPlayer.play();
    }

  });
}

